import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-show-more-button',
  templateUrl: './show-more-button.component.html',
  styleUrls: ['./show-more-button.component.scss']
})
export class ShowMoreButtonComponent implements OnInit {
  @Input() paginationStatus: string;
  @Output() clickEv = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}
}
